import mapboxgl from 'mapbox-gl';
import $ from "jquery";
import * as p from "./popup.js";
let bootstrap = require('bootstrap');

// SR: Provadis_SR_CO2_v_08
mapboxgl.accessToken = 'pk.eyJ1Ijoic3RhbmRhcmQyMDE5IiwiYSI6ImNqeHVlMzd4bzEwbGMzcG41Zm9naDF5cWsifQ.x1Unhj2s-EJP4rVJrctsLQ';
let mapboxStyle = 'mapbox://styles/standard2019/ck2unm5mj3gx31cnyjsx1rqtn';

// FV Dark
// mapboxgl.accessToken = 'pk.eyJ1IjoiZnJpZW5kbHl2aWxsYWdlcnMiLCJhIjoiY2l4NHRsa2gzMDAwbTMzbWd4a3Vwc3U4eCJ9.XbgP-gQDFySmYEP9Cz4LPQ';
// let mapboxStyle = 'mapbox://styles/friendlyvillagers/cjxuldwra2xn41cqygoouh67l/draft';

// FV Provadis_CO2_v_02
// mapboxgl.accessToken = 'pk.eyJ1IjoiZnJpZW5kbHl2aWxsYWdlcnMiLCJhIjoiY2l4NHRsa2gzMDAwbTMzbWd4a3Vwc3U4eCJ9.XbgP-gQDFySmYEP9Cz4LPQ';
// let mapboxStyle = 'mapbox://styles/friendlyvillagers/ck1o4irxl1hii1cmh40573u8t';

//SR at FV
 // mapboxgl.accessToken = 'pk.eyJ1IjoiZnJpZW5kbHl2aWxsYWdlcnMiLCJhIjoiY2l4NHRsa2gzMDAwbTMzbWd4a3Vwc3U4eCJ9.XbgP-gQDFySmYEP9Cz4LPQ';
 // let mapboxStyle = 'mapbox://styles/friendlyvillagers/ck1o4oiiz1hfy1coaqag59okf';

// SR ON FV TEST v04
 // mapboxgl.accessToken = 'pk.eyJ1IjoiZnJpZW5kbHl2aWxsYWdlcnMiLCJhIjoiY2l4NHRsa2gzMDAwbTMzbWd4a3Vwc3U4eCJ9.XbgP-gQDFySmYEP9Cz4LPQ';
 // let mapboxStyle = 'mapbox://styles/friendlyvillagers/ck1qta7690zbt1cqef7sl62w1';

// SR ON FV TEST v06
// mapboxgl.accessToken = 'pk.eyJ1IjoiZnJpZW5kbHl2aWxsYWdlcnMiLCJhIjoiY2l4NHRsa2gzMDAwbTMzbWd4a3Vwc3U4eCJ9.XbgP-gQDFySmYEP9Cz4LPQ';
// let mapboxStyle = 'mapbox://styles/friendlyvillagers/ck1qvbfyx0oi31cpbbt99vp23';

// SR ON FV TEST v07
// mapboxgl.accessToken = 'pk.eyJ1IjoiZnJpZW5kbHl2aWxsYWdlcnMiLCJhIjoiY2l4NHRsa2gzMDAwbTMzbWd4a3Vwc3U4eCJ9.XbgP-gQDFySmYEP9Cz4LPQ';
// let mapboxStyle = 'mapbox://styles/friendlyvillagers/ck1qyl8ui2f8s1cqwvh4dnfgl';


// mapboxgl.accessToken = 'pk.eyJ1Ijoic3RhbmRhcmQyMDE5IiwiYSI6ImNqeHVlMzd4bzEwbGMzcG41Zm9naDF5cWsifQ.x1Unhj2s-EJP4rVJrctsLQ';
// let mapboxStyle = 'mapbox://styles/standard2019/ck1nyzv470enw1cmkf911l3tc';

const bounds = [
  [-55.779793, 12.076000], // Southwest coordinates
  [82.625518,85.714336]  // Northeast coordinates
];
const center = [13.00, 50.00];
const initialZoom = 3.75;
let mapboxControlContainer;
let homeButton = '<button class="mapboxgl-ctrl-icon mapboxgl-ctrl-home" type="button" title="Home" aria-label="Home"></button>';


//------------------------------------------------------------------------
// MAP
//------------------------------------------------------------------------
export let mousePos;
export let zoom;

export const map = new mapboxgl.Map({
  container: 'map',
  style: mapboxStyle,
  center: center,
  zoom: initialZoom,
  maxZoom: 9,
  minZoom: initialZoom,
  maxBounds: bounds
});

//------------------------------------------------------------------------
// LAYERS
//------------------------------------------------------------------------
export let toggleableLayerIds = [];
//filled from data-[topicName].js files:
export let addToggleableLayer = function(layerName){
  toggleableLayerIds.push(layerName);
};

//------------------------------------------------------------------------
// FUNCTIONS
//------------------------------------------------------------------------

//FLY TO
export let flyTo = function(lat, lng){
  map.flyTo({
    center: [lng, lat],
    zoom: 8
  });
};

//HIDE ALL LAYERS
export let hideAllLayers = function(){
  // map.setLayoutProperty('nuts3-outline', 'visibility', 'none');
  // map.setLayoutProperty('NODATA', 'visibility', 'none');
  for (let i = 0; i < toggleableLayerIds.length; i++) {
    map.setLayoutProperty(toggleableLayerIds[i], 'visibility', 'none');
    let element = document.getElementById(toggleableLayerIds[i]);
    element.classList.remove("active");
  }
};

export let showLayer = function(layerName){
  // console.log(layerName);
  map.setLayoutProperty(layerName, 'visibility', 'visible');
  let element = document.getElementById(layerName);
  element.classList.add("active");  
};

//------------------------------------------------------------------------
// MAP LOAD
//------------------------------------------------------------------------
map.on('load', function () {
  setTimeout(function(){
    $('.mapboxgl-map').removeClass('hidden');
  },100);
  setTimeout(function(){
    $('.map-menu').removeClass('hidden');
  },500);

  // NAV
  let nav = new mapboxgl.NavigationControl();
  map.addControl(nav, 'top-right');

  map.resize();
  hideAllLayers();
  showLayer('nuts3-emission-1');
  // setTimeout(showLayer,550, 'nuts3-outline');
  // setTimeout(showLayer,600, 'nuts0-outline');
  // showLayer('nuts3-emission-1');
  // showLayer('nuts0-outline');
  // showLayer('nuts3-outline');

  // HOME
  mapboxControlContainer = $('.mapboxgl-ctrl.mapboxgl-ctrl-group');

  // POPUP
  p.setPopupCount(0);
  let pop = new mapboxgl.Popup();

  //EACH LAYER
  toggleableLayerIds.forEach(function(layerName, i){
  
    let popupHover = new mapboxgl.Popup({
      className: 'hover',
      closeButton: false,
      closeOnClick: false
    });
    // let legendHtml = '<div className="legend"></div>';
    // $('#map').append(legendHtml);
    // let legend = $('.legend');

  }); // EACH LAYER

  //MOUSE MOVE - set zoom + mousePos
  // !!!! MOUSEMOVE NOW IN HOVERREGIONS.JS - dont overwrite!!! TODO remove this
  // map.on('mousemove', function (e) {
  //   zoom = map.getZoom();
  //   mousePos = new mapboxgl.LngLat(e.lngLat.lng, e.lngLat.lat+(0.5/zoom));
  // });

  // ADD HOME
  mapboxControlContainer.append(homeButton);
  mapboxControlContainer.on('click', '.mapboxgl-ctrl-home', function(e) {
    e.preventDefault();
    map.flyTo({
      center: center,
      zoom: initialZoom
    });
  });


}); // MAP load

//----------------------------------------------------------------------